import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface AdminGuardProps {
  children: ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { session, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-state">
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/admin/help/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return (
      <div className="not-found">
        <h1>Access Denied</h1>
        <p>You do not have administrator privileges for the Help Centre.</p>
        <button
          className="btn btn-primary"
          onClick={() => { window.location.href = "/"; }}
        >
          ← Back to Help Centre
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
